module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conclusão Técnica' : 'Editar Conclusão Técnica',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Conclusão Técnica",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatConclusaoTecnica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ff46f26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/ghe/conclusao-tecnica.vue
// module id = 1500
// module chunks = 45